module.exports = __webpack_public_path__ + "img/dots.98880179.svg";